var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 479.64 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FLV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m479.64 125v347a40 40 0 0 1 -40 40h-309.82a40 40 0 0 1 -40-40v-432a40 40 0 0 1 40-40h224.82z",
    fill: "#3d4b9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.64 125h-85a40 40 0 0 1 -40-40v-85z",
    fill: "#2d3a82"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#2d3a82",
    height: 180.68,
    rx: 25,
    width: 362.98,
    y: 240.06
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141.87 335.94h-30.38v32.15h-12.58v-75.36h48.24v10.09h-35.66v23h30.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.18 358h35.3v10h-47.88v-75.27h12.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.7 347.64 1.35 5.49h.31l1.29-5.39 18-55h13.41l-26.91 75.36h-12l-26.86-75.36h13.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlv);
export default __webpack_public_path__ + "static/media/flv.7fa375cbba9b624df0f37cc99a80fcb0.svg";
export { ForwardRef as ReactComponent };